import React from 'react';
import { SITE_FULL_NAME } from '../sitePlaceholders';
import { lnAssets } from '../utils/lnAssets';
import '../styles/I3HeroBrand.css';

export type I3HeroBrandProps = {
  /** Footer / cream sections ? no drop shadow */
  variant?: 'onDark' | 'onLight';
  /** Smaller lockup for footer */
  compact?: boolean;
};

const I3HeroBrand: React.FC<I3HeroBrandProps> = ({ variant = 'onDark', compact = false }) => {
  const className = [
    'i3-hero-brand',
    variant === 'onLight' ? 'i3-hero-brand--on-light' : '',
    compact ? 'i3-hero-brand--compact' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={className}>
      <img
        src={lnAssets.logos.full}
        alt={SITE_FULL_NAME}
        className="i3-hero-brand-full-logo"
        width={compact ? 200 : 520}
        height={compact ? 124 : 320}
        decoding="async"
      />
    </div>
  );
};

export default I3HeroBrand;
